import { withTranslation } from "react-i18next";
import Layout from "/Layout";

export default withTranslation()(function Error404({
  t,
  locale,
}) {
  return (
    <Layout>
      <div class="static-container">
        <h1 class="oneline">{t("errors.not_found")}</h1>
        <a href={`/${locale}`} className="btn btn--dark">{t("common.to_homepage")}</a>
      </div>
    </Layout>
  );
});
